(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  function thumbHTML(opt, hasImg) {
    if (opt && (opt.hasAttribute('data-gift-card-placeholder') || opt.hasAttribute('data-gift-box-placeholder'))) return '';
    if (!hasImg) return '';
    var img = opt.getAttribute('data-img');
    return img
      ? '<img class="img-dd__thumb" src="' + img + '" alt="" loading="lazy" width="34" height="34">'
      : '<span class="img-dd__thumb img-dd__thumb--empty"></span>';
  }

  function syncNoGiftCard(variantPicker) {
    if (!variantPicker) return;
    variantPicker.querySelectorAll('option[data-no-gift-card][data-variant-fallback]').forEach(function (option) {
      option.disabled = false;
      option.classList.remove('disabled');
    });
    var active = Array.prototype.some.call(variantPicker.querySelectorAll('select'), function (variantSelect) {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      return selected && selected.hasAttribute('data-no-gift-card');
    });
    var property = document.querySelector(
      '[data-no-gift-card-property][data-product-section="' + variantPicker.dataset.section + '"]'
    );
    if (property) property.disabled = !active;
    variantPicker.toggleAttribute('data-no-gift-card-selected', active);
  }

  function build(select) {
    if (select.dataset.imgddInit === '1') return;
    var placeholderOption = select.querySelector('option[data-gift-card-placeholder]');
    var noGiftOption = select.querySelector('option[data-no-gift-card]');
    if (placeholderOption && select.firstElementChild !== placeholderOption) {
      select.insertBefore(placeholderOption, select.firstElementChild);
    }
    var noGiftPosition = placeholderOption ? placeholderOption.nextElementSibling : select.firstElementChild;
    if (noGiftOption && noGiftPosition !== noGiftOption) {
      select.insertBefore(noGiftOption, noGiftPosition);
    }
    function hasImages() {
      return Array.prototype.some.call(select.options, function (o) {
        return o.getAttribute('data-img');
      });
    }
    select.dataset.imgddInit = '1';

    var wrap = document.createElement('div');
    wrap.className = 'img-dd' + (hasImages() ? '' : ' img-dd--no-thumb');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('img-dd__native');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'img-dd__toggle';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('ul');
    panel.className = 'img-dd__panel';
    panel.setAttribute('role', 'listbox');

    function renderButton() {
      var opt = select.options[select.selectedIndex];
      var hasImg = hasImages();
      wrap.classList.toggle('img-dd--no-thumb', !hasImg);
      btn.innerHTML =
        (opt ? thumbHTML(opt, hasImg) : '') +
        '<span class="img-dd__label">' + (opt ? opt.textContent : '') + '</span>' +
        '<span class="img-dd__caret"></span>';
    }

    function buildPanel() {
      panel.innerHTML = '';
      var hasImg = hasImages();
      Array.prototype.forEach.call(select.options, function (opt, i) {
        var li = document.createElement('li');
        li.className =
          'img-dd__option' +
          (opt.disabled || opt.classList.contains('disabled') ? ' is-disabled' : '') +
          (i === select.selectedIndex ? ' is-selected' : '');
        li.setAttribute('role', 'option');
        li.innerHTML = thumbHTML(opt, hasImg) + '<span class="img-dd__label">' + opt.textContent + '</span>';
        li.addEventListener('click', function () {
          if (opt.disabled || opt.classList.contains('disabled')) return;
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          close();
        });
        panel.appendChild(li);
      });
    }

    function onDocClick(e) { if (!wrap.contains(e.target)) close(); }
    function open() { buildPanel(); wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); document.addEventListener('click', onDocClick); }
    function close() { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); document.removeEventListener('click', onDocClick); }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      wrap.classList.contains('is-open') ? close() : open();
    });
    select.addEventListener('change', renderButton);
    select.addEventListener('lululocal:image-dropdown-refresh', function () {
      renderButton();
      if (wrap.classList.contains('is-open')) buildPanel();
    });

    wrap.appendChild(btn);
    wrap.appendChild(panel);
    renderButton();
  }

  function init(root) {
    (root || document).querySelectorAll('select.img-select').forEach(build);
  }

  function activateVariantPlaceholders(root) {
    (root || document).querySelectorAll('option[data-gift-card-placeholder]:checked, option[data-gift-box-placeholder]:checked').forEach(function (option) {
      var select = option.parentElement;
      if (!select || select.dataset.variantPlaceholderInit === '1') return;
      select.dataset.variantPlaceholderInit = '1';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function start() {
    init();
    activateVariantPlaceholders();
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      if (vs.dataset.noGiftCardInit !== '1') {
        vs.dataset.noGiftCardInit = '1';
        vs.addEventListener('change', function () { syncNoGiftCard(vs); });
      }
      syncNoGiftCard(vs);
      new MutationObserver(function () {
        init(vs);
        activateVariantPlaceholders(vs);
      }).observe(vs, { childList: true });
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
  } catch(e) { console.error(e); }
})();

})();
